import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import NProgress from 'nprogress';
import {
    $http,
    MAP_LIST
} from '$http';
import classList from '../classListDialog/index.vue' //修改班级
import follow from '../followDialog/index.vue' //跟进
// 新增 编辑
export default {
    mixins: [services],
    components: {
        classList,
        follow
    },
    data() {
        return {
            AddDialogVisible: false,
            loading: false,
            title: '',
            pageIndex: 1,
            pageSize: 10,
            pageSizes: [10, 20, 50],
            totalSize: "",
            OrderData: [],
            SchoolInfo: {},
            ClassInfo: {
                TeacherInfo: {}
            },
            NetInfo: {},
            SalesInfo: {},
            FollowInfo: [],
            ReceiveInfo: [],
            BabyInfo: {}, //下单宝贝
            AgentInfo: {},
            ParentInfo: {}, //下单家长
            isFollow: false,
            Id: ''
        }
    },

    methods: {
        initData() {
            this.OrderData = []
            this.SchoolInfo = {}
            this.ClassInfo = {
                TeacherInfo: {},
            }
            this.NetInfo = {}
            this.SalesInfo = {}
            this.FollowInfo = []
            this.ReceiveInfo = []
            this.BabyInfo = {} //下单宝贝
            this.AgentInfo = {}
            this.ParentInfo = {} //下单家长
        },
        show(opts) {
            this.AddDialogVisible = true
            this.initData();
            this.title = opts.title
            this.isFollow = opts.isFollow
            this.Id = opts.Id
            this.GetById(opts.Id)
        },
        // 修改班级
        changeClass() {
            let title = '配置班级'
            if (this.ClassInfo.ClassId !== '') {
                title = '更换检测班级'
            }
            this.$refs.refsClass.show({
                title: title,
                Id: this.Id,
                ClassId: this.ClassInfo.ClassId
            })
        },
        //查询功能
        handleSizeChange(val) {
            this.pageSize = val;
            this.GetNetWorkCheckDetailList(this.ClassInfo.ClassId, this.BabyInfo.Id)
        },
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.GetNetWorkCheckDetailList(this.ClassInfo.ClassId, this.BabyInfo.Id)
        },
        // 跟进
        followFn() {
            if (this.ClassInfo.ClassId == '' && this.OrderData.OrderFrom !== 1) {
                this.$notify({
                    title: '警告',
                    message: '请先配置班级',
                    type: 'warning'
                });
                return;
            }
            let text = this.SchoolInfo.SchoolName + '-' + this.ClassInfo.ClassName
            if (this.OrderData.OrderFrom == 1) {
                // 联帮在家
                text = this.BabyInfo.BabyName
            }
            this.$refs.refsFollow.show({
                title: '新增跟进',
                Id: this.Id,
                ModuleId: this.OrderData.CheckStatus,
                objectName: text
            })
        },
        //关闭
        close() {
            this.$emit('reloadList')
            this.AddDialogVisible = false
        }

    },
}


// WEBPACK FOOTER //
// ./src/pages/Network/networkCheck/components/networkModalDialog/vm.js